<template>
  <b-modal
    size="lg"
    hide-footer
    v-model="show"
  >
    <template v-slot:modal-header="{ cancel }">
      <h5 class="modal-title">{{title}}</h5>
      <button
        type="button"
        aria-label="Close"
        class="close"
        @click.prevent="cancel"
      >
        <span class="material-icons">
          close
        </span>
      </button>
    </template>
    <FormGenerator
      :data="form.fields"
      :isLoading="isLoading"
      @submit="submit"
    >
      <template v-slot:Projects="slotProps">
        <label class="form__label">{{slotProps.data.label}}</label>
        <multiselect
          v-model="slotProps.data.value"
          tag-placeholder="Select projects"
          :options="slotProps.data.options"
          track-by="id"
          label="name"
          return="id"
          multiple
          :showLabels="false"
        />
      </template>
        <template v-slot:invoiceEmails="slotProps">
            <label class="form__label">{{slotProps.data.label}}</label>
            <div class="row p-1 my-2"  v-for="(_, index) in slotProps.data.value" :key="index" >
                <b-form-input class="col-11" type="email" v-model="slotProps.data.value[index]" :placeholder="slotProps.data.placeholder" />
                <div class="col-1 d-flex justify-content-center">
                    <b-button
                            variant="secondary"
                            class="button btn-icon ml-1"
                            @click="removeInvoiceEmail(index)"
                    >
                        <span class="material-icons">delete</span>
                    </b-button>
                </div>
            </div>
            <div class="row p-1">
                <b-form-input class="col-11" type="email" v-model="newInvoiceEmail" :placeholder="slotProps.data.placeholder" />
                <div class="col-1 d-flex justify-content-center">
                    <b-button
                            variant="secondary"
                            class="button btn-icon"
                            @click="addInvoiceEmail"
                    >
                        <span class="material-icons">save</span>
                    </b-button>
                </div>
            </div>
        </template>
    </FormGenerator>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import FormGenerator from '@components/FormGenerator'

export default {
  components: {
    FormGenerator
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Create client'
    },
    projects: {
      type: Array
    },
    countries: {
      type: Array
    },
    data: {
      type: Object
    },
    value: {
      type: Boolean
    }
  },
  data () {
    return {
      form: {
        fields: {
          'id': {
            name: 'id'
          },
          'first_name': {
            type: 'input',
            name: 'first_name',
            label: 'First Name',
            placeholder: 'First Name',
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          },
          'last_name': {
            type: 'input',
            name: 'last_name',
            label: 'Last Name',
            placeholder: 'Last Name',
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          },
          'company_name': {
            type: 'input',
            name: 'company_name',
            label: 'Company name',
            placeholder: 'Company name',
            value: null,
            class: 'col-12'
          },
          'email': {
            type: 'input',
            typeInput: 'email',
            name: 'email',
            label: 'Email',
            placeholder: 'Email',
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          },
          'invoice_emails': {
            type: 'slot',
            slotName: 'invoiceEmails',
            name: 'invoice_emails',
            label: 'Invoice Emails',
            placeholder: 'Enter invoice email',
            value: [],
            class: 'col-12'
          },
          'phone': {
            type: 'input',
            name: 'phone',
            label: 'Phone',
            placeholder: 'Phone',
            value: null,
            class: 'col-12'
          },
          'projects': {
            type: 'slot',
            slotName: 'Projects',
            name: 'project_ids',
            label: 'Projects',
            selectLabel: 'name',
            valueField: 'id',
            options: [],
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          },
          'country': {
            type: 'select',
            name: 'country_id',
            label: 'Country',
            selectLabel: 'name',
            valueField: 'id',
            options: [],
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          },
          'city': {
            type: 'input',
            name: 'city',
            label: 'City',
            placeholder: 'City',
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          },
          'address': {
            type: 'input',
            name: 'address',
            label: 'Address',
            placeholder: 'Address',
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          },
          'zip_code': {
            type: 'input',
            name: 'zip_code',
            label: 'Zip Code',
            placeholder: 'Zip Code',
            value: null,
            class: 'col-12'
          }
        }
      },
      newInvoiceEmail: ''
    }
  },
  computed: {
    ...mapGetters({
      getCountries: 'countries/getCountries',
      getProjects: 'projects/getProjects'
    }),
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    'projects': {
      deep: true,
      handler () {
        this.setProject()
      }
    },
    'countries': {
      deep: true,
      handler () {
        this.setCountries()
      }
    },
    'data': {
      deep: true,
      handler () {
        this.setParamsForEditBankDetailsModal()
      }
    }
  },
  created () {
    this.setInitialForm()
  },
  methods: {
    setInitialForm () {
      this.setCountries()
      this.setProject()
      this.setParamsForEditBankDetailsModal()
    },
    async setCountries () {
      let countries = this.countries

      if (!this.countries) {
        await this.fetchCountries()
        countries = this.getCountries
      }

      this.form.fields.country.options = countries
    },
    async setProject () {
      let projects = this.projects

      if (!this.projects) {
        await this.fetchProjects()
        projects = this.getProjects
      }

      this.form.fields.projects.options = projects
    },
    async fetchCountries () {
      if (this.getCountries.length) return

      return this.$api.country.getCountries()
    },
    async fetchProjects () {
      return this.$api.projects.getProjects()
    },
    setParamsForEditBankDetailsModal () {
      if (!this.data) return

      let value = ''

      for (let key in this.form.fields) {
        if (this.data[key]) {
          value = this.data[key]
        } else {
          value = ''
        }

        this.form.fields[key]['value'] = value
      }
    },
    addInvoiceEmail () {
      if (this.newInvoiceEmail && this.newInvoiceEmail !== '') {
        this.form.fields.invoice_emails.value.push(this.newInvoiceEmail)
        this.newInvoiceEmail = ''
      }
    },
    removeInvoiceEmail (index) {
      this.form.fields.invoice_emails.value.splice(index, 1)
    },
    submit (data) {
      this.$emit('submit', data)
    }
  }
}
</script>
